import { useNavigate, useOutletContext } from 'react-router-dom';
import { RiskFlowControl } from 'types/RiskControl';

export const useFunctions = () => {
  const navigate = useNavigate();
  const outletContext = useOutletContext<RiskFlowControl>();

  const { riskFlow, setRiskFlow } = outletContext;

  const handleNextStep = () => {
    setRiskFlow({
      ...riskFlow,
      hadSuccess: true,
      hadError: false,
      riskProcessed: true,
    });
  };

  const handleCancel = () => {
    setRiskFlow({
      ...riskFlow,
      riskProcessed: true,
      hadSuccess: undefined,
    });
  };

  const handleNewFreight = () => {
    handleNextStep();
    navigate('/meus-fretes/cadastrar');
  };

  return { handleNextStep, handleCancel, handleNewFreight };
};
